import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { MatSort, MatSortHeader } from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import { Router } from '@angular/router'
import {
  DataContextBuilder,
  ElderBasicPaneLayoutComponent,
  ElderDataToolbarComponent,
  ElderPaneComponent,
  ElderSearchBoxComponent,
  ElderSearchContextDirective,
  ElderTableComponent,
  ElderTableToolbarDirective,
  ElderToolbarContentDirective,
  IDataContext,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { WorkStationType } from '../work-station-type'
import { WorkStationTypeService } from '../work-station-type.service'

@Component({
  selector: 'app-work-station-type-browser',
  templateUrl: './work-station-type-browser.component.html',
  styleUrls: ['./work-station-type-browser.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    ElderTableToolbarDirective,
    ElderDataToolbarComponent,
    ElderToolbarContentDirective,
    ElderSearchBoxComponent,
    ElderSearchContextDirective,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    MatSortHeader,
    ElderTranslatePipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class WorkStationTypeBrowserComponent implements OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly data: IDataContext<WorkStationType>
  private router = inject(Router)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const typeService = inject(WorkStationTypeService)
    this.data = DataContextBuilder.start<WorkStationType>()
      .pageSize(50)
      .reloadOnLocalChanges()
      .autoStartAsap()
      .build(typeService)
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnDestroy(): void {
    if (this.data) {
      this.data.close()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public openDetail(wct: WorkStationType): void {
    this.router.navigate([{ outlets: { side: ['work-stations', 'types', wct.id] } }], {
      preserveFragment: true,
    })
  }

  public create(): void {
    this.router.navigate([{ outlets: { side: ['work-stations', 'types', 'new'] } }], {
      preserveFragment: true,
    })
  }
}
